import axios from 'axios'
import store from '../store'
import { URL } from '../const'

import {
  POSTING_FORM,
  POST_FORM_SUCCESS,
  POST_FORM_FAIL,
  POSTING_CSV,
  POST_CSV_SUCCESS,
  POST_CSV_FAIL,
  SHOW_TOAST,
  HIDE_TOAST,
  RESET_FORM
} from '../actions/types'

export const postForm = (category, data, redirect) => async dispatch => {
  dispatch({ type: POSTING_FORM })
  const url = `${URL}${category}`

  const config = {
    headers: {
      'Authorization': `Token ${store.getState().user.token}`
    }
  }
  console.log('data: ', data)

  try {
    const res = await axios.post(
      url,
      data,
      config
    )
    console.log('res: ', res)
    dispatch({
      type: POST_FORM_SUCCESS
    })
    if (redirect) {
      console.log('redirect: ', redirect)
      redirect()
    }
    showToast(dispatch, '保存しました！', 'primary')
  } catch (error) {
    console.log('error: ', error)
    dispatch({ type: POST_FORM_FAIL })
    showToast(dispatch, 'エラーが発生しました。', 'danger')
  }
}

export const postFormWithImage = (category, data, image, redirect) => async dispatch => {
  dispatch({ type: POSTING_FORM })

  const url = `${URL}${category}`
  const config = {
    headers: {
      'Authorization': `Token ${store.getState().user.token}`,
      'Content-Type': 'multipart/form-data'
    }
  }

  // console.log('data: ', JSON.stringify(data))

  const formData = new FormData()
  formData.append('data', JSON.stringify(data))
  if (image) {
    const imageExtension = image.name.split('.').pop()
    const imageName = `${category}-${data.id || '000'}-${Date.now()}.${imageExtension}`

    console.log('image: ', image)
    console.log('imageName: ', imageName)
    formData.append('image', image, imageName)
  }

  try {
    const res = await axios.post(
      url,
      formData,
      config
    )
    console.log('res: ', res)
    dispatch({
      type: POST_FORM_SUCCESS
    })
    if (redirect) {
      console.log('redirect: ', redirect)
      redirect()
    }
    showToast(dispatch, '保存しました！', 'primary')
  } catch (error) {
    console.log('error: ', error)
    dispatch({ type: POST_FORM_FAIL })
    showToast(dispatch, 'エラーが発生しました。', 'danger')
  }
}

export const postCSV = (data, csv) => async dispatch => {
  dispatch({ type: POSTING_CSV })

  const url = `${URL}csv`
  const config = {
    headers: {
      'Authorization': `Token ${store.getState().user.token}`,
      'Content-Type': 'multipart/form-data'
    }
  }
  console.log('url: ', url)
  console.log('data: ', JSON.stringify(data))

  const formData = new FormData()
  formData.append('data', JSON.stringify(data))
  if (csv) {
    formData.append('file', csv)
  }

  try {
    const res = await axios.post(
      url,
      formData,
      config
    )
    console.log('res: ', res)
    dispatch({
      type: POST_CSV_SUCCESS
    })
    showToast(dispatch, '追加しました！', 'primary')
  } catch (error) {
    console.log('error: ', error)
    dispatch({ type: POST_CSV_FAIL })
    showToast(dispatch, 'エラーが発生しました。', 'danger')
  }
}

export const resetForm = () => {
  return ({ type: RESET_FORM })
}

const showToast = function (dispatch, toastMessage, toastColor) {
  console.log('show')
  dispatch({
    type: SHOW_TOAST,
    payload: {
      toastMessage,
      toastColor
    }
  })

  setTimeout(() => {
    console.log('timeout')
    dispatch({ type: HIDE_TOAST })
  }, 3000)
}



// WEBPACK FOOTER //
// ./src/actions/postActions.js